var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('b-row',[_c('b-col',{attrs:{"lg":"12","sm":"12"}},[_c('vs-button',{attrs:{"color":"primary","type":"filled","size":"small","icon":"edit"},on:{"click":function($event){return _vm.kartDetay()}}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }